export const addButtonStyle = {
  default: {
    position: 'fixed',
    right: 45,
    top: 136,
    transform: 'scaleX(0.8) scaleY(0.8)!important',
  },
  noHeadStyle: {
    top: 152,
    right: 20,
    position: 'fixed',
    transform: 'scaleX(0.8) scaleY(0.8)!important',
  },
  noSearchPanelStyle: {
    top: 88,
    right: 20,
    position: 'fixed',
    transform: 'scaleX(0.8) scaleY(0.8)!important',
  },
  small: {
    top: 8,
    right: 28,
    position: 'absolute',
    transform: 'scaleX(0.6) scaleY(0.6)!important',
  },
  categoryList: {
    top: 12,
    right: 34,
    position: 'absolute',
    transform: 'scaleX(0.6) scaleY(0.6)!important',
  },
  smallTreeView: {
    transform: 'scaleX(0.5) scaleY(0.5)!important',
  },
  smallDocumentFieldType: {
    top: '-1px',
    right: 38,
    position: 'absolute',
    transform: 'scaleX(0.6) scaleY(0.6)!important',
  },
  tableHeadSmallTop: {
    position: 'absolute',
    top: -20,
    right: -10,
    transform: 'scaleX(0.6) scaleY(0.6) !important',
  },
  relative: {
    position: 'relative',
    transform: 'scaleX(0.6) scaleY(0.6)!important',
  },
  absolute: {
    position: 'absolute',
  },
};

export const emptyLayoutConfig = {
  config: {
    toolbar: {
      display: false,
    },
  },
};
